import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Phone, MapPin, Mail, Clock } from "lucide-react";

const categoryLinks = [
  "Detergent rufe albe",
  "Detergent rufe colorate",
  "Detergent rufe negre",
  "Balsam de rufe",
];

export default function Footer() {
  const navigate = useNavigate();

  const goToCategory = (cat) => {
    navigate(`/produse?categorie=${encodeURIComponent(cat)}`);
  };

  return (
    <footer className="mt-auto bg-slate-900 text-slate-300" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 lg:grid-cols-4 lg:px-12">
        <div>
          <div className="mb-4 flex items-center gap-2">
            <img src="/logo-icon.png" alt="Mimaso" className="h-10 w-auto" />
            <span className="font-display text-2xl font-black text-white">mimaso</span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Detergenți și balsamuri concentrate, cu formule cu enzime naturale.
            Curățenie profesională, direct de la producător la tine acasă.
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-display text-lg font-bold text-white">Navigare</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/produse" className="transition-colors hover:text-sky-400">Produse</Link></li>
            <li><Link to="/oferte" className="transition-colors hover:text-sky-400">Oferte lunare</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-sky-400">Contact</Link></li>
            <li><Link to="/contul-meu" className="transition-colors hover:text-sky-400">Contul meu</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-lg font-bold text-white">Categorii</h4>
          <ul className="space-y-2.5 text-sm">
            {categoryLinks.map((cat) => (
              <li key={cat}>
                <button
                  type="button"
                  onClick={() => goToCategory(cat)}
                  className="text-left transition-colors hover:text-sky-400"
                  data-testid={`footer-category-${cat.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  {cat}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-lg font-bold text-white">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" /> One Tool SRL · Centru Logistic, Chiajna, Ilfov</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-sky-400" /> <a href="tel:+40734154845" className="hover:text-sky-400">+40 734 154 845</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-sky-400" /> comenzi@mimasodirect.ro</li>
            <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-sky-400" /> Luni - Vineri: 09:00 - 18:00</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-6 lg:px-12">
          <div className="flex flex-wrap items-center justify-center gap-4" data-testid="anpc-banners">
            <a
              href="https://anpc.ro/ce-este-sal/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-opacity hover:opacity-80"
              data-testid="anpc-sal-link"
            >
              <img src="/anpc-sal.svg" alt="ANPC - Soluționarea Alternativă a Litigiilor (SAL)" className="h-11 w-auto rounded" loading="lazy" />
            </a>
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-opacity hover:opacity-80"
              data-testid="anpc-sol-link"
            >
              <img src="/anpc-sol.svg" alt="ANPC - Soluționarea Online a Litigiilor (SOL)" className="h-11 w-auto rounded" loading="lazy" />
            </a>
          </div>
          <p className="text-center text-xs text-slate-500">
            © {new Date().getFullYear()} Mimaso · One Tool SRL. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>
  );
}
